'use client';

import type { Icon } from '@personly/libs-types';
import { Requirement } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';

import { usePasswords } from '@/providers/passwords';

interface Props {
  icon?: Icon;
}

const PasswordRequirement = ({ icon }: Props) => {
  const { password } = usePasswords();
  const { validate, requirement } = useValidators();

  return (
    password.length > 0 &&
    !validate('PASSWORD', password) && (
      <Requirement icon={icon}>{requirement('PASSWORD')}</Requirement>
    )
  );
};

export default PasswordRequirement;
